import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyB-BqWOfns3Z1n_WCPuo6HnxIqIfFpvISU",
  authDomain: "extent-protocol-a.firebaseapp.com",
  databaseURL: "https://realtime-sawir.firebaseio.com",
  projectId: "extent-protocol-a",
  storageBucket: "extent-protocol-a.firebasestorage.app",
  messagingSenderId: "407916756981",
  appId: "1:407916756981:web:ab8582208d33cf4f356abc",
  measurementId: "G-PW6XH9K3WP",
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase services
export const storage = getStorage(app);
export const db = getDatabase(app);
